<template>
<v-container fluid fill-height>
  <h1>Recommender Portal for the Ross Mathematics Program</h1>
  <p>This website will help you submit a recommendation letter for an applicant to the Ross Program.</p>
  <p>If you are writing a recommendation letter, you should have received an email with a link.  Please click on the link in that email.  If you are having trouble, contact <a href="mailto:ross@rossprogram.org">ross@rossprogram.org</a> for help.</p>
</v-container>
</template>

<script>
export default {
};
</script>
